<script setup lang="ts">
import {default as templateStore} from "@/store";
</script>

<script lang="ts">
import {defineComponent} from 'vue'
import store from "@/store";

export default defineComponent({
    name: 'ToolTip',

    data(): {
        properties: {[property: string]: string}
        offset: number
    } {
        return {
            properties: {},
            offset: 30,
        }
    },

    computed: {
        style(): {[property: string]: string}
        {
            const properties: {[property: string]: string} = this.properties

            const x: number = store.state.cursor.x
            const y: number = store.state.cursor.y

            const width: number = window.innerWidth
            const height: number = window.innerHeight

            if (x <= width / 2 + 250) {
                properties.left = `${x + this.offset}px`
                properties.right = `auto`
            } else {
                properties.left = `auto`
                properties.right = `${width - x + this.offset}px`
            }

            if (y <= height / 2) {
                properties.bottom = `auto`
                properties.top = `${y + this.offset}px`
            } else {
                properties.bottom = `${height - y + this.offset}px`
                properties.top = `auto`
            }

            return properties
        }
    }
})
</script>

<template>
    <div
        class="content"
        v-if="templateStore.state.passBonus"
        :style="style"
        v-html="templateStore.state.passBonus.description"
    >
    </div>
</template>

<style scoped lang="scss">
.content {
    position: fixed;
    z-index: 5000;
    max-width: 400px;
    padding: 3px 7px 3px 7px;
    background: rgba(0, 0, 0, 0.9);
    box-shadow: 0 0 12px 4px black;
    border-radius: 10px;
    color: white;
    font-size: 15px;
    top: 100px;
    left: 100px;
}
</style>
